<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                <p class="mt-4 subtitle-1">Accesso in corso...</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'impersonate',
    mounted() {
        this.$store.commit('endProgress')

        const token = this.$route.query.token
        const fqdn = this.$route.query.fqdn

        if (!token || !fqdn) {
            this.$router.replace('/login')
            return
        }

        // Salva fqdn e configura axios baseURL
        localStorage.setItem('fqdn', fqdn)
        this.$store.dispatch('SET_FQDN')

        // Salva token e setta header Authorization
        this.$store.commit('AUTH_SUCCESS', { token: token })

        // Segna sessione come impersonazione
        localStorage.setItem('is_impersonating', 'true')

        // Carica profilo utente e redirige alla dashboard
        this.$store.dispatch('USER_REQUEST').then(() => {
            this.$router.replace('/')
        }).catch(() => {
            localStorage.removeItem('is_impersonating')
            this.$router.replace('/login')
        })
    }
}
</script>
